import { TranslateLoader } from "@ngx-translate/core";
import { HttpClient } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TableComponent } from './table/table.component';
import { PagerComponent } from './pager/pager.component';
import { RepeaterComponent } from './repeater/repeater.component';
import { ListComponent } from './list/list.component';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { RouterModule } from "@angular/router";
@NgModule({
  declarations: [
    TableComponent,
    PagerComponent,
    RepeaterComponent,
    ListComponent
  ],
  imports: [CommonModule,TranslateModule,FormsModule, RouterModule],
  exports: [TableComponent, PagerComponent, RepeaterComponent, ListComponent,TranslateModule],
  providers: [TranslateService],
})
export class ListModule { }
export function httpLoaderFactory(httpClient: HttpClient) {
  //return new TranslateHttpLoader(httpClient);
}
